@if (!isOpen()) {
  <button
    type="button"
    class="app-shell__chat"
    [attr.aria-label]="'layout.header.chatAria' | translate"
    (click)="onLauncherClick()"
  >
    <img
      src="assets/icons/envelope-email.svg"
      alt=""
      width="50"
      height="50"
      class="app-shell__chat-icon"
    />
  </button>
}
